import { PublicClientApplication } from "@azure/msal-browser";
import { instance } from "../boot";
import getBaseUrl from "./getBaseUrl";

const acquireAccessToken = async (msalInstance: PublicClientApplication) => {
    //console.log("AF: acquireAccessToken start: ");
    const activeAccount = msalInstance.getActiveAccount(); // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API
    const accounts = msalInstance.getAllAccounts();
    //console.log("AF: activeAccount: " + activeAccount + " accounts.length: " + accounts.length);
    if (!activeAccount && accounts.length === 0) {
        /*
        * User is not signed in. Throw error or wait for user to login.
        * Do not attempt to log a user in outside of the context of MsalProvider
        */
    }
    let config = require(`../config.${HostingEnv}.ts`) as any;

    const scope = BQS
        ? config.authRequestBQS.scopes[0]
        : config.authRequestCQS.scopes[0];
    const request = {
        scopes: [scope],
        account: activeAccount || accounts[0],
        interactionType: 'Silent'
    };
    //console.log("AF: acquiring token silently...");
    await msalInstance.acquireTokenSilent(request).then((response) => {
        if (response) {
            localStorage.setItem("access_token", response.accessToken);
        }
    })
        .catch(async (err) => {
            //console.log("AF: Silent token acquisition failed, acquiring token interactively...", err);

            await instance.loginRedirect({
                scopes: [scope],
                account: activeAccount || accounts[0]
            });
        });
};

export default async function apifetch(input: RequestInfo, init?: RequestInit, authenticate?: boolean): Promise<Response> {
    //console.log("AF: authenticate: " + authenticate);

    if (authenticate) {
        await acquireAccessToken(instance);

        let accessToken = localStorage.getItem("access_token");
        let authToken = localStorage.getItem("authorization_token");
        if (accessToken !== null && authToken !== null) {
            init = init || {};
            init.headers = init.headers || new Headers();
            let headers = init.headers as Headers;
            headers.append("Authorization", `Bearer ${accessToken}`);
            headers.append('CustomAuthorizationToken', `CustomAuthToken ${authToken}`);
        }
    }

    return fetch(`${getBaseUrl()}api/${input}`, init);
}


// WEBPACK FOOTER //
// ./ClientApp/utils/apifetch.ts